import { request } from '@/api/client'
import type { AsideData } from '@/features/resources/types'

/** One client whose update sheets were dropped because the account has no WhatsApp group. */
export interface NoGroupClient {
  accountId: number
  accountName: string
  /** Sheets that were built and dropped — recorded by the daily run, not inferred. */
  skipped: number
  /** Shipment rows those sheets carried. */
  rows: number
  kinds: Record<string, number>
  days: string[]
  lastAt: number
  /** The account had a group on another day in the window: it was removed or changed, not never set. */
  hadGroupBefore: boolean
}

export interface NoGroupSummary {
  fromDay: string
  toDay: string
  days: number
  totalClients: number
  totalSkipped: number
  totalRows: number
  activeClients: number
}

export const clientsNoGroup = (days = 30, signal?: AbortSignal) =>
  request<NoGroupClient[]>('/ext/clients/no-group', { query: { days }, signal }).then((r) => ({
    clients: r.data ?? [],
    summary: r.summary as NoGroupSummary | undefined,
  }))

/**
 * The clients screen's "شغالة من غير جروب" toggle: the accounts that had work with us in the last 30 days and whose
 * update sheet was dropped for want of a WhatsApp group. One call for the whole list, never one per row.
 */
export const clientsWithNoGroup = (): Promise<AsideData> => clientsNoGroup(30).then((r) => ({ ids: new Set(r.clients.map((c) => c.accountId)) }))
